import { render, staticRenderFns } from "./BrowserCaptureImage.vue?vue&type=template&id=4fd600a0&scoped=true"
import script from "./BrowserCaptureImage.vue?vue&type=script&lang=js"
export * from "./BrowserCaptureImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd600a0",
  null
  
)

export default component.exports